import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";
import { IconByName } from "@/components/icons";

const SERVICES = [
  {
    number: "01",
    icon: "Users",
    title: "Personal presencial",
    description:
      "Orientação próxima durante o treino, com atenção à execução e à sua evolução.",
  },
  {
    number: "02",
    icon: "Globe",
    title: "Consultoria online",
    description:
      "Treinamento personalizado para você seguir com organização e acompanhamento.",
  },
];

export default function ServicesManifesto() {
  return (
    <section id="sobre" className="relative scroll-mt-20 py-24 sm:py-28" data-testid="services-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Acompanhamento"
          title="Seu objetivo merece um treino pensado para você."
          sub="Sou Fernando Martins Júnior, personal trainer da FW Team Fitness. Meu trabalho é ajudar você a evoluir com treinos adaptados à sua realidade, ao seu nível e aos seus objetivos."
          testId="services-heading"
        />

        <div className="mx-auto mt-14 grid max-w-4xl grid-cols-1 gap-4 sm:grid-cols-2" data-testid="services-manifesto-grid">
          {SERVICES.map((service, i) => (
            <motion.article
              key={service.number}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: i * 0.09, ease: [0.22, 1, 0.36, 1] }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#0d121c]/70 p-7 shadow-[0_4px_24px_rgba(0,0,0,0.5)] transition-colors duration-300 hover:border-brand-teal/50"
              data-testid={`service-card-${i + 1}`}
            >
              <span
                className="pointer-events-none absolute -right-2 -top-7 select-none font-display text-[7rem] font-black leading-none text-white/[0.04] transition-colors duration-300 group-hover:text-brand-blue/[0.07]"
                aria-hidden="true"
              >
                {service.number}
              </span>
              <span className="font-mono text-sm font-semibold tracking-[0.2em] text-brand-blue/80">
                {service.number}
              </span>
              <div className="mt-6 flex h-12 w-12 items-center justify-center rounded-xl border border-brand-teal/40 bg-brand-teal/15 text-brand-blue">
                <IconByName name={service.icon} className="h-6 w-6" />
              </div>
              <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-white sm:text-2xl">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">
                {service.description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
